<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="workplaces"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-row>
                        <v-col cols="12" sm="12" md="8">
                          <v-combobox
                            v-model="editedItem.name"
                            :items="workplaces"
                            item-text="name"
                            item-value="name"
                            :return-object="false"
                            :label="$t('label.laboratory')"
                            :rules="rules.fieldRequired"
                          ></v-combobox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.place_code"
                            label="Codigo"
                            :rules="rules.fieldRequired"
                          />
                        </v-col>
                      </v-row>
                      <v-row class="align-center">
                        <v-col cols="12" sm="5">
                          <v-text-field
                            v-model="editedItem.network_socket"
                            :label="$t('form.workplace.network_socket')"
                            :rules="rules.char_max_10"
                          />
                        </v-col>
                        <v-col cols="12" sm="7">
                          <v-text-field
                            v-model="editedItem.file_cabinet"
                            :label="$t('form.workplace.file_cabinet')"
                            :rules="rules.char_max_30"
                          />
                        </v-col>
                      </v-row>
                      <v-row class="align-center">
                        <v-col cols="12" sm="5">
                          <v-text-field
                              v-model="editedItem.extension"
                              :label="$t('form.workplace.extension')"
                          />
                        </v-col>
                        <v-col cols="11" sm="6">
                          <v-autocomplete
                            :items="hosts"
                            item-text="hostname"
                            item-value="id"
                            v-model="editedItem.host"
                            label="Host"
                            clearable
                          ></v-autocomplete>
                        </v-col>
                        <v-col class="align-center" cols="1">
                          <v-btn
                              icon
                              to="/manage/edit/hosts"
                              target="_blank"
                              text
                          >
                            <v-icon
                                color="green"
                                v-tooltip.top-center="$t('info.tooltip.addHost')"
                            >
                              mdi-new-box
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-checkbox
                            v-model="editedItem.hidden"
                            :label="$t('table.hidden')"
                            :rules="rules.checkboxRequired"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">{{ $t("button.cancel") }}</v-btn>
                  <v-btn color="primary" @click="save">{{
                    $t("button.save")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.hostname="{ item }">{{
            getHostName(item.host)
          }}</template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" color="accent" @click="$router.push('/building#' + item.place_code.toLowerCase().replace('-','_').replace('ñ','nh'))">
            mdi-floor-plan
          </v-icon>
          <v-icon class="mr-2" color="primary" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
export default {
  mixins: [validationRules],
  data() {
    return {
      dialog: false,
      search: this.$route.hash.replace("#",""),
      workplaces: [],
      hosts: [],
      editedIndex: -1,
      editedItem: {
        name: "",
        place_code: "",
        extension: "",
        network_socket: "",
        file_cabinet: ""
      },
      defaultItem: {
        name: "",
        place_code: "",
        extension: "",
        network_socket: "",
        file_cabinet: ""
      }
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("title.newItem")
        : this.$t("title.editItem");
    },
    headers() {
      return [
        {
          text: this.$t("form.workplace.name"),
          value: "name"
        },
        {
          text: this.$t("forms.building"),
          value: "place_code"
        },
        {
          text: "Host",
          value: "hostname"
        },
        {
          text: this.$t("form.workplace.network_socket"),
          value: "network_socket"
        },
        {
          text: this.$t("form.workplace.extension"),
          value: "extension"
        },
        {
          text: this.$t("form.workplace.file_cabinet"),
          value: "file_cabinet"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
    this.getHosts();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/workplace";
      axios
        .get(path)
        .then(response => {
          this.workplaces = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getHosts() {
      let path = this.$store.state.endpoint + "/host";
      axios
        .get(path)
        .then(response => {
          this.hosts = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getHostName(item) {
      if (item !== null) {
        if (typeof item === "number") {
          return this.hosts.find(host => host.id === item).hostname;
        } else {
          return item.hostname;
        }
      } else {
        return null;
      }
    },

    editItem(item) {
      this.editedIndex = this.workplaces.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.id = item.id;
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/workplace/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.workplaces.indexOf(item);
            this.workplaces.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        const index = this.editedIndex;
        const data = this.editedItem;
        if (this.editedItem.host !== undefined && this.editedItem.host !== null && this.editedItem.host.id !== undefined){
          data['host'] = this.editedItem.host.id;
        }
        if (index > -1) {
          path =
            this.$store.state.endpoint + "/workplace/" + this.editedItem.id;
          axios
            .patch(path, this.editedItem)
            .then(response => {
              data.host = response.data.host;
              Object.assign(this.workplaces[index], data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/workplace";
          const data = this.editedItem;
          axios
            .post(path, data)
            .then(response => {
              data.id = response.data.id;
              data.host = response.data.host;
              this.workplaces.push(data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
        this.close();
      }
    }
  }
};
</script>
